import { fork } from "redux-saga/effects"

import parcelList from "./parcels/list"
import parcelSingle from "./parcels/single"

export default function* main() {
  yield fork(parcelList)
  yield fork(parcelSingle)
}



// WEBPACK FOOTER //
// ./src/data/sagas/index.js